import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Login } from './Login';
import { LanguageSelect } from './LanguageSelect';

export const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { token, loading } = useAuth();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!loading && token) {
      const redirect = searchParams.get('redirect');
      if (redirect && redirect.startsWith('/')) {
        navigate(redirect);
        return;
      }
      navigate('/desk');
    }
  }, [token, loading, navigate, searchParams]);

  if (loading) {
    return null;
  }

  if (token) {
    return null;
  }

  return (
    <div className="min-h-screen bg-background pt-8">
      <div className="mx-auto mb-4 flex w-full max-w-[400px] justify-end px-4">
        <LanguageSelect />
      </div>
      <Login onSwitchToSignup={() => navigate('/register')} />
    </div>
  );
};
